import { Route, Routes } from "react-router-dom"

import PassareOrganizationDetail from "./passare/detail/PassareOrganizationDetail"
import PassareCaseDetail from "./passare/detail/PassareCaseDetail"
import PassareLeadDetail from "./passare/detail/PassareLeadDetail"
import PassareManagement from "./passare/PassareManagement"

function PassareRoutes() {
    return (
        <>
            <Routes>
                <Route path='manage' element={<PassareManagement />} />
                <Route path='organizations/:passare_organization_unique_identifier/*' element={<PassareOrganizationDetail />} />
                <Route path='cases/:passare_case_unique_identifier/*' element={<PassareCaseDetail />} />
                <Route path='leads/:passare_acquaintance_unique_identifier/*' element={<PassareLeadDetail />} />
            </Routes>
        </>
    )
}

export default PassareRoutes